(() => {
  const init = () => {
    document.querySelectorAll('[data-ss-mobile-nav]').forEach((drawer) => {
      if (drawer.dataset.ready === 'true') return;
      drawer.dataset.ready = 'true';

      const syncScrollLock = () => {
        document.documentElement.classList.toggle('ss-menu-open', drawer.open);
      };
      const close = () => {
        drawer.removeAttribute('open');
        syncScrollLock();
      };

      drawer.addEventListener('toggle', syncScrollLock);
      drawer.querySelector('[data-ss-menu-close]')?.addEventListener('click', close);
      drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    document.documentElement.classList.remove('ss-menu-open');
  });
})();

/* Keeps the header cart count in sync after AJAX cart updates (add, change, remove). */
(() => {
  const render = (count) => {
    document.querySelectorAll('[data-ss-cart-count]').forEach((node) => {
      node.textContent = count;
      node.toggleAttribute('hidden', count === 0);
      const action = node.closest('.ss-cart-action');
      if (action) action.setAttribute('aria-label', `Cart, ${count} items`);
    });
  };

  const refresh = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      render(cart.item_count);
    } catch {
      /* leave the server-rendered count in place */
    }
  };

  ['shopify:cart:lines-update', 'shopify:cart:note-update', 'shopify:cart:attributes-update'].forEach((name) =>
    document.addEventListener(name, refresh)
  );
})();
